document.addEventListener("DOMContentLoaded", function(event) {

  if (document.getElementById('js-proInstallBlock')) {
    const title = document.getElementById("js-proTitle"),
      show = function(target) {
        document.getElementById(target).style.display = 'block';
      };

    if (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) && !((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) && !(navigator.userAgent.search(/YaBrowser/) > 0)) {
      show("js-proChorme");
    } else {
      title.innerHTML = title.dataset.other;
      show("js-proOther");
    }

  }

});
